<template>
    <div
        v-if="hasReady"
        class="collection-editor edit-collection-page admin-weflix-edit-collection weflix-admin-editCollection"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <main class="collection-editor__container">
            <nav class="collection-editor__breadcrumb" aria-label="Trilha">
                <router-link to="/admin/colecoes">Coleções</router-link>
                <span class="collection-editor__breadcrumb-sep" aria-hidden="true">
                    <fa icon="fa-chevron-right" />
                </span>
                <span>Editar coleção</span>
            </nav>

            <header class="collection-editor__page-header">
                <div>
                    <h1 class="collection-editor__title">Editar Coleção</h1>
                    <p class="collection-editor__subtitle">
                        Atualize as informações, configuração de venda e a capa da sua coleção de vídeos.
                    </p>
                </div>
                <div class="collection-editor__header-actions">
                    <button
                        type="button"
                        class="collection-editor__btn collection-editor__btn--delete"
                        @click="showDeleteConfirm"
                    >
                        <fa icon="fa-trash" />
                        Excluir coleção
                    </button>
                </div>
            </header>

            <div class="collection-editor__grid">
                <div class="collection-editor__column">
                    <section class="collection-editor__card collection-editor__card--info">
                        <div class="collection-editor__card-header">
                            <span class="collection-editor__card-icon" aria-hidden="true">
                                <fa icon="fa-circle-info" />
                            </span>
                            <div>
                                <h2 class="collection-editor__card-title">Informações da coleção</h2>
                                <p class="collection-editor__card-description">
                                    Defina os detalhes principais da sua coleção.
                                </p>
                            </div>
                        </div>

                        <div class="collection-editor__field">
                            <div class="collection-editor__label-row">
                                <label class="collection-editor__label" for="edit-collection-name">
                                    Nome da coleção
                                </label>
                                <v-tooltip text="Campo obrigatório" location="top">
                                    <template v-slot:activator="{ props }">
                                        <fa
                                            v-bind="props"
                                            class="collection-editor__help"
                                            icon="fa-solid fa-circle-exclamation"
                                        />
                                    </template>
                                </v-tooltip>
                            </div>
                            <input
                                id="edit-collection-name"
                                type="text"
                                required
                                class="collection-editor__input"
                                v-model="nameCollection"
                                placeholder="Nome da coleção"
                            />
                            <small class="collection-editor__helper">
                                Nome comercial da sua coleção, uso externo.
                            </small>
                        </div>

                        <div class="collection-editor__field">
                            <div class="collection-editor__label-row">
                                <label class="collection-editor__label" for="edit-collection-description">
                                    Descrição da coleção
                                </label>
                                <v-tooltip text="Campo obrigatório" location="top">
                                    <template v-slot:activator="{ props }">
                                        <fa
                                            v-bind="props"
                                            class="collection-editor__help"
                                            icon="fa-solid fa-circle-exclamation"
                                        />
                                    </template>
                                </v-tooltip>
                            </div>
                            <textarea
                                id="edit-collection-description"
                                class="collection-editor__textarea"
                                v-model="descriptionCollection"
                                maxlength="300"
                                placeholder="Descrição da coleção"
                            ></textarea>
                            <small class="collection-editor__counter">
                                {{ descriptionCount }}/300 caracteres
                            </small>
                        </div>

                        <div class="collection-editor__field">
                            <div class="collection-editor__label-row">
                                <label class="collection-editor__label" for="edit-collection-status">
                                    Status da coleção
                                </label>
                            </div>
                            <small class="collection-editor__helper collection-editor__helper--tight">
                                Define se a coleção está ativa ou inativa.
                            </small>
                            <div
                                class="collection-editor__select-wrap"
                                :class="{ 'is-active': isActiveStatus }"
                            >
                                <span
                                    v-if="isActiveStatus"
                                    class="collection-editor__status-dot"
                                    aria-hidden="true"
                                ></span>
                                <select
                                    id="edit-collection-status"
                                    v-model="status"
                                    class="collection-editor__select"
                                >
                                    <option value="1">Ativo</option>
                                    <option value="0">Inativo</option>
                                </select>
                            </div>
                        </div>
                    </section>

                    <section class="collection-editor__card collection-editor__card--sale">
                        <div class="collection-editor__card-header">
                            <span class="collection-editor__card-icon" aria-hidden="true">
                                <fa icon="fa-cart-shopping" />
                            </span>
                            <div>
                                <h2 class="collection-editor__card-title" id="edit-collection-venda-type-label">
                                    Tipo de venda
                                </h2>
                                <p class="collection-editor__card-description">
                                    Escolha como essa coleção será disponibilizada para os alunos.
                                </p>
                            </div>
                        </div>

                        <div
                            class="collection-editor__sale-options"
                            role="radiogroup"
                            aria-labelledby="edit-collection-venda-type-label"
                        >
                            <div
                                class="collection-editor__sale-option"
                                :class="{ 'collection-editor__sale-option--selected': !vendaAvulsa }"
                                @click="vendaAvulsa = false"
                            >
                                <input
                                    type="radio"
                                    v-model="vendaAvulsa"
                                    :value="false"
                                    id="edit-collection-venda-assinatura"
                                />
                                <span class="collection-editor__radio" aria-hidden="true"></span>
                                <label for="edit-collection-venda-assinatura">
                                    <span class="collection-editor__sale-head">
                                        <fa icon="fa-users" />
                                        <span class="collection-editor__sale-title">Assinatura</span>
                                    </span>
                                    <span class="collection-editor__sale-desc">
                                        Acesso através de plano mensal, semestral ou anual ou seu plano personalizado.
                                    </span>
                                </label>
                            </div>
                            <div
                                class="collection-editor__sale-option"
                                :class="{ 'collection-editor__sale-option--selected': vendaAvulsa }"
                                @click="vendaAvulsa = true"
                            >
                                <input
                                    type="radio"
                                    v-model="vendaAvulsa"
                                    :value="true"
                                    id="edit-collection-venda-avulsa"
                                />
                                <span class="collection-editor__radio" aria-hidden="true"></span>
                                <label for="edit-collection-venda-avulsa">
                                    <span class="collection-editor__sale-head">
                                        <fa icon="fa-cart-shopping" />
                                        <span class="collection-editor__sale-title">Venda avulsa</span>
                                    </span>
                                    <span class="collection-editor__sale-desc">
                                        Compra única com acesso temporário.
                                    </span>
                                </label>
                            </div>
                        </div>
                    </section>

                    <section class="collection-editor__card collection-editor__card--price">
                        <div class="collection-editor__card-header">
                            <span class="collection-editor__card-icon" aria-hidden="true">
                                <fa icon="fa-tag" />
                            </span>
                            <div>
                                <h2 class="collection-editor__card-title">Preço e disponibilidade</h2>
                                <p class="collection-editor__card-description">
                                    Configure o valor, tempo de acesso e opções de pagamento.
                                </p>
                            </div>
                        </div>

                        <div v-if="!vendaAvulsa" class="collection-editor__notice">
                            <h4>Modelo de Assinatura</h4>
                            <p>
                                No modelo de assinatura, o conteúdo do curso será disponibilizado junto aos demais em um modelo de assinatura.
                            </p>
                        </div>

                        <div v-if="vendaAvulsa" class="collection-editor__price-grid">
                            <div class="collection-editor__field">
                                <label class="collection-editor__label" for="edit-collection-price">Preço (R$)</label>
                                <div class="collection-editor__price-field">
                                    <span class="collection-editor__currency">R$</span>
                                    <input
                                        id="edit-collection-price"
                                        type="text"
                                        class="collection-editor__input"
                                        v-model="preco"
                                        placeholder="0,00"
                                        @input="
                                            (e) =>
                                                (e.target.value = e.target.value
                                                    .replace(/[^0-9,]/g, '')
                                                    .replace(/(,.*?),/g, '$1'))
                                        "
                                        @blur="
                                            (e) => {
                                                const value =
                                                    parseFloat(
                                                        e.target.value.replace(',', '.')
                                                    ) || 0;
                                                e.target.value = value
                                                    .toFixed(2)
                                                    .replace('.', ',');
                                                preco = value;
                                            }
                                        "
                                    />
                                </div>
                            </div>
                            <div class="collection-editor__field">
                                <label class="collection-editor__label" for="edit-collection-days">
                                    Tempo de disponibilidade
                                </label>
                                <div class="collection-editor__select-wrap">
                                    <select
                                        id="edit-collection-days"
                                        v-model="tempoDisponibilidade"
                                        class="collection-editor__select"
                                    >
                                        <option value="30">30 dias</option>
                                        <option value="60">60 dias</option>
                                        <option value="90">90 dias</option>
                                        <option value="180">180 dias</option>
                                        <option value="360">360 dias</option>
                                    </select>
                                </div>
                            </div>
                            <div class="collection-editor__field">
                                <label class="collection-editor__label" for="edit-collection-installments">
                                    Número de parcelas
                                </label>
                                <div class="collection-editor__select-wrap">
                                    <select
                                        id="edit-collection-installments"
                                        v-model="instalments"
                                        class="collection-editor__select"
                                    >
                                        <option value="1">1x</option>
                                        <option value="2">2x</option>
                                        <option value="3">3x</option>
                                        <option value="4">4x</option>
                                        <option value="5">5x</option>
                                        <option value="6">6x</option>
                                        <option value="7">7x</option>
                                        <option value="8">8x</option>
                                        <option value="9">9x</option>
                                        <option value="10">10x</option>
                                        <option value="11">11x</option>
                                        <option value="12">12x</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <aside class="collection-editor__column">
                    <section class="collection-editor__card collection-editor__card--cover">
                        <div class="collection-editor__card-header">
                            <span class="collection-editor__card-icon" aria-hidden="true">
                                <fa icon="fa-image" />
                            </span>
                            <div>
                                <h2 class="collection-editor__card-title">Capa da coleção</h2>
                                <p class="collection-editor__card-description">
                                    Esta imagem será exibida para os alunos na vitrine da coleção.
                                </p>
                            </div>
                        </div>

                        <div class="collection-editor__cover-frame">
                            <img
                                v-if="imagePreviewCover"
                                class="collection-editor__cover-preview"
                                :src="imagePreviewCover"
                                alt="Capa da coleção"
                            />
                            <span v-else class="collection-editor__cover-empty">Nenhuma capa enviada</span>
                        </div>

                        <label
                            class="collection-editor__upload"
                            @dragover.prevent
                            @drop.prevent="onDropCover"
                        >
                            <input
                                class="collection-editor__file"
                                type="file"
                                @change="updateFileCover"
                                accept=".png, .jpg, .jpeg, .webp"
                            />
                            <span class="collection-editor__upload-icon" aria-hidden="true">
                                <fa v-if="loaderImage" icon="fa-cloud-arrow-up" />
                                <LoaderImage :hasReady="loaderImage" />
                            </span>
                            <span class="collection-editor__upload-title">Trocar imagem da capa</span>
                            <span class="collection-editor__upload-text">
                                Clique para enviar ou arraste um arquivo aqui
                            </span>
                            <span class="collection-editor__upload-hint">
                                PNG ou JPG • 1920 × 200 px (recomendado)
                            </span>
                        </label>
                    </section>

                    <section class="collection-editor__card collection-editor__card--summary">
                        <div class="collection-editor__card-header">
                            <span class="collection-editor__card-icon" aria-hidden="true">
                                <fa icon="fa-clipboard-list" />
                            </span>
                            <div>
                                <h2 class="collection-editor__card-title">Resumo da coleção</h2>
                                <p class="collection-editor__card-description">
                                    Visualize um resumo das configurações.
                                </p>
                            </div>
                        </div>

                        <div class="collection-editor__summary-row">
                            <span class="collection-editor__summary-icon"><fa icon="fa-file-lines" /></span>
                            <span class="collection-editor__summary-label">Nome</span>
                            <span class="collection-editor__summary-value">{{ summaryName }}</span>
                        </div>
                        <div class="collection-editor__summary-row">
                            <span class="collection-editor__summary-icon"><fa icon="fa-circle" /></span>
                            <span class="collection-editor__summary-label">Status</span>
                            <span class="collection-editor__summary-value">
                                <span
                                    v-if="summaryStatusLabel !== 'Não informado'"
                                    class="collection-editor__badge"
                                    :class="isActiveStatus ? 'collection-editor__badge--active' : 'collection-editor__badge--inactive'"
                                >
                                    {{ summaryStatusLabel }}
                                </span>
                                <template v-else>Não informado</template>
                            </span>
                        </div>
                        <div class="collection-editor__summary-row">
                            <span class="collection-editor__summary-icon"><fa icon="fa-cart-shopping" /></span>
                            <span class="collection-editor__summary-label">Tipo de venda</span>
                            <span class="collection-editor__summary-value">{{ summarySaleType }}</span>
                        </div>
                        <div class="collection-editor__summary-row">
                            <span class="collection-editor__summary-icon"><fa icon="fa-tag" /></span>
                            <span class="collection-editor__summary-label">Preço</span>
                            <span class="collection-editor__summary-value">{{ summaryPrice }}</span>
                        </div>
                        <div class="collection-editor__summary-row">
                            <span class="collection-editor__summary-icon"><fa icon="fa-clock" /></span>
                            <span class="collection-editor__summary-label">Tempo de disponibilidade</span>
                            <span class="collection-editor__summary-value">{{ summaryAvailability }}</span>
                        </div>
                        <div class="collection-editor__summary-row">
                            <span class="collection-editor__summary-icon"><fa icon="fa-credit-card" /></span>
                            <span class="collection-editor__summary-label">Parcelas</span>
                            <span class="collection-editor__summary-value">{{ summaryInstallments }}</span>
                        </div>
                    </section>
                </aside>
            </div>
        </main>

        <footer class="collection-editor__footer">
            <div class="collection-editor__footer-inner">
                <button
                    type="button"
                    class="collection-editor__btn collection-editor__btn--back"
                    @click="$router.push(`/admin/colecao/${idCollection}`)"
                >
                    <fa icon="fa-arrow-left" />
                    Voltar
                </button>
                <button
                    type="button"
                    class="collection-editor__btn collection-editor__btn--save"
                    @click="editCollection"
                    :disabled="!loaderImage"
                >
                    <fa icon="fa-floppy-disk" />
                    Salvar alterações
                </button>
            </div>
        </footer>
    </div>

    <v-dialog v-model="showConfirmDialog" :max-width="440">
        <v-card class="modal-card">
            <v-card-title>
                <h3 class="mb-0">Deseja realmente excluir essa coleção?</h3>
            </v-card-title>
            <v-card-subtitle>
                Esta ação não poderá ser desfeita.
            </v-card-subtitle>
            <v-card-text>
                <p class="mb-1">
                    Nome: <strong>"{{ nameCollection }}"</strong>
                </p>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="flex-grow-1 cancel-btn"
                    color="grey-darken-4"
                    variant="tonal"
                    @click="showConfirmDialog = false"
                    >Cancelar</v-btn
                >
                <v-btn
                    class="flex-grow-1 text-white"
                    color="danger"
                    variant="flat"
                    :loading="isLoading"
                    :disabled="isLoading"
                    @click="deleteCollection"
                    >Excluir</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Loader v-if="!hasReady" />
</template>


<script>
    import apiCollections from '@/utils/Weflix/collections';
    import Loader from '@/components/Weflix/Loader';
    import apiAWS from '@/utils/storage/aws';
    import LoaderImage from '@/components/Weflix/LoaderImage';
    import { mapState, mapActions } from 'vuex';
    import { toast } from 'vue3-toastify';

    export default {
        data() {
            return {
                collection: {},
                nameCollection: '',
                descriptionCollection: '',
                deleteItem: false,
                nameItem: '',
                imagePreviewCover: '',
                imagePreviewCover2: '',
                hasReady: false,
                idCollection: '',
                imageCover: '',
                imageCover2: '',
                loaderImage: true,
                loaderImage2: true,
                vendaAvulsa: false,
                preco: 0,
                tempoDisponibilidade: 1,
                instalments: 1,
                status: 1,
                showConfirmDialog: false,
                url: '',
            };
        },
        computed: {
            ...mapState(['token']),
            isActiveStatus() {
                return String(this.status) === '1';
            },
            descriptionCount() {
                return (this.descriptionCollection || '').length;
            },
            summaryName() {
                const name = (this.nameCollection || '').trim();
                return name || 'Não informado';
            },
            summaryStatusLabel() {
                if (this.status === '' || this.status == null) return 'Não informado';
                return this.isActiveStatus ? 'Ativo' : 'Inativo';
            },
            summarySaleType() {
                return this.vendaAvulsa ? 'Venda avulsa' : 'Assinatura';
            },
            summaryPrice() {
                if (!this.vendaAvulsa) return 'Não informado';
                return this.formatCurrency(this.preco);
            },
            summaryAvailability() {
                if (!this.vendaAvulsa) return 'Não informado';
                return this.availabilityLabel(this.tempoDisponibilidade);
            },
            summaryInstallments() {
                if (!this.vendaAvulsa || this.instalments === '' || this.instalments == null) {
                    return 'Não informado';
                }
                return `${this.instalments}x`;
            },
        },
        components: {
            Loader,
            LoaderImage,
        },
        methods: {
            ...mapActions(['storeCurrentCollections']),
            deleteVideo(id, name) {
                this.deleteItem = true;
                this.nameItem = name;
            },
            closeDialog() {
                this.deleteItem = false;
            },
            async getCollection() {
                const param = this.$route.params.slug;
                try {
                    const response = await apiCollections.getCollectionById(
                        this.token,
                        param
                    );
                    this.collection = response;
                    this.nameCollection = response.name;
                    this.descriptionCollection = response.shortDescription;
                    this.imagePreviewCover = response.imageFinalPath;
                    this.imageCover = response.imagePath;
                    this.imagePreviewCover2 = response.imageFinalPath2;
                    this.imageCover2 = response.imagePath2;
                    this.vendaAvulsa = response.price > 0 ? true : false;
                    this.preco = response.price || 0;
                    this.tempoDisponibilidade = response.dayExpired || 1;
                    this.instalments = response.installment;
                    this.status = response.status || 1;
                    this.hasReady = true;
                    this.url = response.url;
                } catch (error) {
                    console.error('Erro ao obter dados da coleção:', error);
                }
            },
            async editCollection() {
                this.hasReady = false;
                const param = this.$route.params.slug;
                const payload = {
                    comercialName: this.nameCollection,
                    name: this.nameCollection,
                    status: this.status,
                    shortDescription: this.descriptionCollection,
                    imagePath: this.imageCover,
                    imagePath2: this.imageCover2,
                    url: this.nameCollection
                        .toLowerCase()
                        .replace(/\s+/g, '-')
                        .replace(/[ç]/g, 'c')
                        .replace(/[^\w-]/g, ''),
                    vendaAvulsa: this.vendaAvulsa,
                    price: this.vendaAvulsa ? this.preco : 0,
                    dayExpired: this.vendaAvulsa
                        ? this.tempoDisponibilidade
                        : null,
                    installment: this.vendaAvulsa ? this.instalments : null,
                };
                try {
                    const response = await apiCollections.editCollection(
                        this.token,
                        param,
                        payload
                    );
                    this.storeCurrentCollections({
                        currentCollections: response,
                    });
                    this.collection = response;
                    this.hasReady = true;
                    this.notify('Coleção editada com sucesso!', 'success');
                } catch (error) {
                    this.notify('Erro ao obter dados da coleção!', 'error');
                    console.error('Erro ao obter dados da coleção:', error);
                }
            },
            updateContentLongDescription(value) {
                this.description = value;
            },
            async putFileAws(url, file) {
                try {
                    const response = await apiAWS.putFileAWS(url, file);
                } catch (error) {
                    console.error('Erro ao enviar arquivo para AWS');
                }
            },
            onDropCover(event) {
                const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
                if (!file) return;
                this.updateFileCover({ target: { files: [file] } });
            },
            async updateFileCover(event) {
                this.loaderImage = false;
                const file = event.target.files[0];
                this.imagePreviewCover = URL.createObjectURL(file);
                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.imageCover = response.token;
                    this.loaderImage = true;
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFileCover2(event) {
                this.loaderImage2 = false;
                const file = event.target.files[0];
                this.imagePreviewCover2 = URL.createObjectURL(file);
                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.imageCover2 = response.token;
                    this.loaderImage2 = true;
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            showDeleteConfirm() {
                this.showConfirmDialog = true;
            },

            async deleteCollection() {
                this.hasReady = false;
                try {
                    await apiCollections.deleteCollection(
                        this.token,
                        this.idCollection
                    );
                    await this.$router.push({ path: '/admin/colecoes' });
                } catch (error) {
                    console.error('Erro ao excluir coleção:', error);
                } finally {
                    this.showConfirmDialog = false;
                    this.hasReady = true;
                }
            },
            formatCurrency(value) {
                if (value === '' || value == null) return 'Não informado';
                let num = value;
                if (typeof value !== 'number') {
                    const raw = String(value).trim();
                    num = raw.includes(',')
                        ? parseFloat(raw.replace(/\./g, '').replace(',', '.'))
                        : parseFloat(raw);
                }
                if (!Number.isFinite(num)) return 'Não informado';
                return num.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                });
            },
            availabilityLabel(value) {
                const map = {
                    30: '30 dias',
                    60: '60 dias',
                    90: '90 dias',
                    180: '180 dias',
                    360: '360 dias',
                    365: '365 dias',
                };
                if (value === '' || value == null || value === 1 || value === '1') {
                    return 'Não informado';
                }
                return map[value] || map[Number(value)] || `${value} dias`;
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
        created() {
            this.getCollection();
            this.idCollection = this.$route.params.slug;
        },
    };
</script>

<style>
    @import url('@/css/weflix/collection-editor.css');
</style>
